export default __webpack_public_path__ + "static/media/PlusOne2.59683408.svg";